import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { CustomImage, Text, CustomPageHeader, successDialog } from '@src/components';

import OrderSummaryInformation from './orderSummary/OrderSummaryInformation';
import CardDetailInformation from './orderSummary/CardDetailInformation';

import {
  setResetDetailList,
  setActiveStep,
  setTotalAutoLoading,
  setResetInstructionsTempList,
  instructionAdd,
} from '@src/store/slice/autoUploadInstructionsSlice';

import { Button } from 'antd';

import iconBack from '@src/assets/icons/icon-back.svg';
import '@src/styles/autoUploadInstruction/orderSummary.scss';

const ConfirmInstruction = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { totalAutoLoading } = useSelector((state) => state?.autoUploadInstructions);

  const params = new URLSearchParams(history.location.search);
  let integrationId = params.get('updateId') ?? 0;
  if (!integrationId) {
    integrationId = params.get('instructionId') ?? 0;
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleOrderApproval = useCallback(async () => {
    const body = {
      integrationId: integrationId,
      autoLoadingCreateRequestDto: {
        periodType: totalAutoLoading?.periodType,
        confirmEveryMonth: totalAutoLoading?.confirmEveryMonth,
        startDay: totalAutoLoading?.startDay,
        orderProcessType: totalAutoLoading?.orderProcessType,
        isConfirmOrder: true,
        isActive: totalAutoLoading?.isActive,
        monthChoice: totalAutoLoading?.chooseMonth,
      },
    };

    const action = await dispatch(instructionAdd(body));

    if (instructionAdd.fulfilled.match(action)) {
      successDialog({
        title: <Text t="successfullyApproved" />,
        message: 'Otomatik yükleme talimatınız başarıyla onaylandı.',
        onOk: () => {
          handleCancelOrder();
        },
        onCancel: () => {},
      });
    }
  }, [dispatch, totalAutoLoading?.totalPrice]);

  const handleCancelOrder = useCallback(async () => {
    await dispatch(setResetDetailList([]));
    await dispatch(setResetInstructionsTempList([]));
    await dispatch(setActiveStep(0));
    await dispatch(
      setTotalAutoLoading({
        orderProcessType: 2,
        periodType: 1,
        startDay: 1,
        confirmEveryMonth: totalAutoLoading?.confirmEveryMonth,
        totalCount: 0,
        totalPrice: 0,
        totalPaymentPrice: 0,
        vouId: 1,
        segId: 1000,
        monthChoice: false,
        monthlyPrice: 0.0,
      }),
    );

    await history.push(`/ticket-restaurant/auto-upload-instructions`);
  }, [history]);

  return (
    <CustomPageHeader
      data-testid="new-instruction"
      title={<Text t="automaticInstallationInstruction" />}
      showBreadCrumb
      showHelpButton
      routes={['Ticket Restaurant', 'automaticInstallationInstructions']}
    >
      <div className="auto-upload-instructions">
        <div className="autoUploadInstruction-instruction-summary-content">
          <OrderSummaryInformation />

          <div className="step-btn-container-summary-balance">
            <Button
              id="autoUploadInstructions-orderSummary-main-back-btn"
              className="back-btn"
              onClick={handleCancelOrder}
            >
              <CustomImage src={iconBack} />
              <Text t="turnBack" />
            </Button>

            <div className={'right-btn-container'}>
              <Button
                id="autoUploadInstructions-orderSummary-main-next-btn"
                className="next-btn"
                onClick={handleOrderApproval}
              >
                <Text t="approveInstruction" />
              </Button>
            </div>
          </div>

          <CardDetailInformation />
        </div>
      </div>
    </CustomPageHeader>
  );
};

export default ConfirmInstruction;
